"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "Legal Aid Society of Mid-New York, Inc.",
  address: "268 Genesee Street, Utica, NY 13502",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-society-mid-new-york-inc-program-profile",
  phone: "(315) 793-7000",
  city: "Utica",
  state: "NY"
}, {
  name: "Legal Aid Society of Northeastern New York, Inc.",
  address: "95 Central Avenue, Albany, NY 12206",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-society-northeastern-new-york-inc-program-profile",
  phone: "(518) 462-6765",
  city: "Albany",
  state: "NY"
}, {
  name: "Legal Assistance of Western New York, Inc.",
  address: "361 South Main Street, Geneva, NY 14456",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-assistance-western-new-york-inc-program-profile",
  phone: "(315) 781-1465",
  city: "Geneva",
  state: "NY"
}, {
  name: "Nassau/Suffolk Law Services Committee, Inc.",
  address: "One Helen Keller Way, 5th Floor, Hempstead, NY 11550",
  phone: "(516) 292-8100",
  city: "Hempstead",
  state: "NY",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/nassausuffolk-law-services-committee-inc-program-profile"
}, {
  name: "Bay Area Legal Aid",
  address: "1735 Telegraph Avenue, Oakland, CA 94612",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/bay-area-legal-aid-program-profile",
  phone: "(510) 663-4755",
  city: "Oakland",
  state: "CA"
}, {
  name: "California Indian Legal Services, Inc.",
  address: "609 S. Escondido Boulevard, Escondido, CA 92025",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/california-indian-legal-services-inc-program-profile",
  phone: "(760) 746-8941",
  city: "Escondido",
  state: "CA"
}, {
  name: "California Rural Legal Assistance, Inc.",
  address: "1430 Franklin Street, Suite 103, Oakland, CA 94612",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/california-rural-legal-assistance-inc-program-profile",
  phone: "(510) 267-0762",
  city: "Oakland",
  state: "CA"
}, {
  name: "Central California Legal Services",
  address: "2115 Kern Street, Suite 1, Fresno, CA 93721",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/central-california-legal-services-program-profile",
  phone: "(559) 570-1200",
  city: "Fresno",
  state: "CA"
}, {
  name: "Inland Counties Legal Services, Inc.",
  address: "1040 Iowa Avenue, Suite 109, Riverside, CA 92507-2106",
  phone: "(951) 368-2530",
  city: "Riverside",
  state: "CA",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/inland-counties-legal-services-inc-program-profile"
}, {
  name: "Land of Lincoln Legal Assistance Foundation, Inc.",
  address: "8787 State Street, Suite 201, East St. Louis, IL 62203",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/land-lincoln-legal-assistance-foundation-inc-program-profile",
  phone: "(618) 398-0574",
  city: "East St. Louis",
  state: "IL"
}, {
  name: "Legal Aid Chicago",
  address: "120 South LaSalle Street, Suite 900, Chicago, IL 60603-3425",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-chicago-program-profile",
  phone: "(312) 347-8359",
  city: "Chicago",
  state: "IL"
}, {
  name: "Prairie State Legal Services, Inc.",
  address: "303 North Main Street, Suite 600, Rockford, IL 61101",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/prairie-state-legal-services-inc-program-profile",
  phone: "(815) 965-2134",
  city: "Rockford",
  state: "IL"
}, {
  name: "Justice Entrepreneurs Project",
  address: "208 S Jefferson, Suite 204, Chicago, IL 60661",
  url: "https://jepchicago.community.lawyer/",
  phone: "(312) 546-3282",
  city: "Chicago",
  state: "IL"
}, {
  name: "Legal Aid of NorthWest Texas",
  address: "600 East Weatherford Street, Fort Worth, TX 76102",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-northwest-texas-program-profile",
  phone: "(817) 649-4740",
  city: "Fort Worth",
  state: "TX"
}, {
  name: "Lone Star Legal Aid",
  address: "1415 Fannin Street, Houston, TX 77002",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/lone-star-legal-aid-program-profile",
  phone: "(713) 652-0077",
  city: "Houston",
  state: "TX"
}, {
  name: "Texas RioGrande Legal Aid, Inc.",
  address: "301 South Texas Avenue, Mercedes, TX 78570",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/texas-riogrande-legal-aid-inc-program-profile",
  phone: "(512) 374-2725",
  city: "Mercedes",
  state: "TX"
}, {
  name: "Laurel Legal Services, Inc.",
  address: "16 E. Otterman Street, Greensburg, PA 15601-3066",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/laurel-legal-services-inc-program-profile",
  phone: "(724) 836-2211",
  city: "Greensburg",
  state: "PA"
}, {
  name: "Legal Aid of Southeastern Pennsylvania",
  address: "625-627 Swede Street, Norristown, PA 19401-4801",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-southeastern-pennsylvania-program-profile",
  phone: "(610) 275-5400",
  city: "Norristown",
  state: "PA"
}, {
  name: "MidPenn Legal Services, Inc.",
  address: "213-A North Front Street, Harrisburg, PA 17101",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/midpenn-legal-services-inc-program-profile",
  phone: "(717) 234-0492",
  city: "Harrisburg",
  state: "PA"
}, {
  name: "Neighborhood Legal Services Association",
  address: "928 Penn Avenue, Pittsburgh, PA 15222-3799",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/neighborhood-legal-services-association-program-profile",
  phone: "(412) 255-6700",
  city: "Pittsburgh",
  state: "PA"
}, {
  name: "Northwestern Legal Services",
  address: "Renaissance Center, Suite 700, 1001 State Street, Erie, PA 16501-1828",
  phone: "(814) 452-8129",
  city: "Erie",
  state: "PA",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/northwestern-legal-services-program-profile"
}, {
  name: "Community Legal Services of Philadelphia",
  address: "1424 Chestnut Street, Philadelphia, PA 19102",
  url: "https://clsphila.org/get-help/bankruptcy",
  phone: "(215) 981-3700",
  city: "Philadelphia",
  state: "PA"
}, {
  name: "Philadelphia Legal Assistance",
  address: "718 Arch Street, Suite 300N, Philadelphia, PA 19106",
  url: "https://philalegal.org/",
  phone: "(215) 981-3800",
  city: "Philadelphia",
  state: "PA"
}, {
  name: "Community Legal Services, Inc.",
  address: "305 South 2nd Avenue, P.O. Box 21538, Phoenix AZ 85036-1538",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/community-legal-services-inc-program-profile",
  phone: "(602) 258-3434",
  city: "Phoenix",
  state: "AZ"
}, {
  name: "DNA-Peoples Legal Services, Inc.",
  address: "Route 12, Highway 264, P.O. Box 306, Window Rock, AZ 86515-0306",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/dna-peoples-legal-services-inc-program-profile",
  phone: "(928) 871-5630",
  city: "Window Rock",
  state: "AZ"
}, {
  name: "Southern Arizona Legal Aid, Inc.",
  address: "Continental Building, 2343 East Broadway, Suite 200, Tucson, AZ 85719",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/southern-arizona-legal-aid-inc-program-profile",
  phone: "(520) 623-9465",
  city: "Tucson",
  state: "AZ"
}, {
  name: "Indiana Legal Services, Inc.",
  address: "Market Square Ctr., Suite 1850, 151 North Delaware Street, Indianapolis, IN 46204-2523",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/indiana-legal-services-inc-program-profile",
  phone: "(317) 631-9410",
  city: "Indianapolis",
  state: "IN"
}, {
  name: "Bay Area Legal Services, Inc.",
  address: "1302 N. 19th Street, Suite 400, Tampa, FL 33605",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/bay-area-legal-services-inc-program-profile",
  phone: "(813) 232-1343",
  city: "Tampa",
  state: "FL"
}, {
  name: "Coast to Coast Legal Aid of South Florida, Inc.",
  address: "491 North State Road 7, Plantation, FL 33317",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/coast-coast-legal-aid-south-florida-inc-program-profile",
  phone: "(954) 736-2400",
  city: "Plantation",
  state: "FL"
}, {
  name: "Community Legal Services of Mid-Florida, Inc.",
  address: "128 Orange Avenue, Suite 300, Daytona Beach, FL 32114-4310",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/community-legal-services-mid-florida-inc-program-profile",
  phone: "(386) 255-6573",
  city: "Daytona Beach",
  state: "FL"
}, {
  name: "Florida Rural Legal Services, Inc.",
  address: "1321 E. Memorial Boulevard, Lakeland, FL 33801",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/florida-rural-legal-services-inc-program-profile",
  phone: "(863) 688-7376",
  city: "Lakeland",
  state: "FL"
}, {
  name: "Legal Services of North Florida, Inc.",
  address: "2119 Delta Boulevard, Tallahassee, FL 32303-4209",
  phone: "(850) 385-9007",
  city: "Tallahassee",
  state: "FL",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-services-north-florida-inc-program-profile"
}, {
  name: "Community Legal Aid Services, Inc.",
  address: "50 South Main Street, Akron, OH 44308",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/community-legal-aid-services-inc-program-profile",
  phone: "(330) 535-4191",
  city: "Akron",
  state: "OH"
}, {
  name: "Legal Aid of Western Ohio, Inc.",
  address: "525 Jefferson Avenue, Suite 400, Toledo OH 43604-1371",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-western-ohio-inc-program-profile",
  phone: "(419) 724-0030",
  city: "Columbus",
  state: "OH"
}, {
  name: "The Legal Aid Society of Cleveland",
  address: "1223 West Sixth Street, Cleveland, OH 44113-1354",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-society-cleveland-program-profile",
  phone: "(216) 687-1900",
  city: "Cleveland",
  state: "OH"
}, {
  name: "Legal Aid Society of Greater Cincinnati",
  address: "215 East Ninth Street, Suite 200, Cincinnati, OH 45202",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-society-greater-cincinnati-program-profile",
  phone: "(513) 241-9400",
  city: "Cincinnati",
  state: "OH"
}, {
  name: "Legal Aid of North Carolina, Inc.",
  address: "224 South Dawson Street, Raleigh NC 27601-6087",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-north-carolina-inc-program-profile",
  phone: "(919) 856-2564",
  city: "Charlotte",
  state: "NC"
}, {
  name: "Lakeshore Legal Aid",
  address: "Robert A. Verkuilen Building, 21885 Dunham Road, Suite 4, Clinton Township, MI 48036",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/lakeshore-legal-aid-program-profile",
  phone: "(586) 469-5185",
  city: "Clinton Township",
  state: "MI"
}, {
  name: "Legal Aid of Western Michigan",
  address: "25 Division South Ste 300, Grand Rapids, MI 49503",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-western-michigan-program-profile",
  phone: "(616) 774-0672",
  city: "Grand Rapids",
  state: "MI"
}, {
  name: "Legal Services of Eastern Michigan",
  address: "436 South Saginaw Street, Flint, MI 48502",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-services-eastern-michigan-program-profile",
  phone: "(810) 234-2621",
  city: "Flint",
  state: "MI"
}, {
  name: "Legal Services of Northern Michigan, Inc.",
  address: "806 Ludington Street, Escanaba, MI 49829",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-services-northern-michigan-inc-program-profile",
  phone: "(989) 705-1067",
  city: "Escanaba",
  state: "MI"
}, {
  name: "Michigan Indian Legal Services, Inc.",
  address: "814 South Garfield Avenue, Suite A, Traverse City, MI 49686-2401",
  phone: "(231) 947-0122",
  city: "Traverse City",
  state: "MI",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/michigan-indian-legal-services-inc-program-profile"
}, {
  name: "Legal Aid of East Tennessee",
  address: "607 W Summit Hill Dr, Knoxville, TN 37902-2011",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-east-tennessee-program-profile",
  phone: "(865) 637-0484",
  city: "Knoxville",
  state: "TN"
}, {
  name: "Legal Aid Society of Middle Tennessee and the Cumberlands",
  address: "1321 Murfreesboro Pike Ste 400, Nashville, TN 37217-2665",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-society-middle-tennessee-and-cumberlands-program-profile",
  phone: "(615) 780-7118",
  city: "Nashville",
  state: "TN"
}, {
  name: "Memphis Area Legal Services, Inc.",
  address: "Falls Building, 22 N. Front Street, 11th Floor, Memphis, TN 38103-5013",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/memphis-area-legal-services-inc-program-profile",
  phone: "(901) 523-8822",
  city: "Memphis",
  state: "TN"
}, {
  name: "West Tennessee Legal Services, Inc.",
  address: "210 W. Main Street, P.O. Box 2066, Jackson, TN 38302-2066",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/west-tennessee-legal-services-inc-program-profile",
  phone: "(731) 426-1311",
  city: "Jackson",
  state: "TN"
}, {
  name: "Northwest Justice Project",
  address: "401 Second Avenue South, Suite 407, Seattle, WA 98104",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/northwest-justice-project-program-profile",
  phone: "(206) 464-1519",
  city: "Seattle",
  state: "WA"
}, {
  name: "Colorado Legal Services",
  address: "1905 Sherman Street, Suite 400, Denver, CO 80203",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/colorado-legal-services-program-profile",
  phone: "(303) 866-9399",
  city: "Denver",
  state: "CO"
}, {
  name: "Neighborhood Legal Services Program of the District of Columbia",
  address: "64 New York Avenue, NE Ste 180, Washington, DC 20002",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/neighborhood-legal-services-program-district-columbia-program-profile",
  phone: "(202) 269-5100",
  city: "Washington",
  state: "DC"
}, {
  name: "Community Legal Aid, Inc.",
  address: "405 Main Street, Worcester, MA 01608",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/community-legal-aid-inc-program-profile",
  phone: "(508) 752-3718",
  city: "Worcester",
  state: "MA"
}, {
  name: "Northeast Legal Aid, Inc.",
  address: "50 Island Street, Suite #203A, Lawrence, MA 01840",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/northeast-legal-aid-inc-program-profile",
  phone: "(978) 458-1465",
  city: "Lawrence",
  state: "MA"
}, {
  name: "South Coastal Counties Legal Services",
  address: "22 Bedford Street, 2nd Floor, P.O. Box 2507, Fall River, MA 02722",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/south-coastal-counties-legal-services-program-profile",
  phone: "(508) 979-7160",
  city: "Fall River",
  state: "MA"
}, {
  name: "Volunteer Lawyers Project of the Boston Bar Association",
  address: "99 Chauncy Street, Suite 400, Boston, MA 02111",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/volunteer-lawyers-project-boston-bar-association-program-profile",
  phone: "(617) 423-0648",
  city: "Boston",
  state: "MA"
}, {
  name: "Maryland Legal Aid",
  address: "500 East Lexington Street, Baltimore, MD 21202",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/maryland-legal-aid-program-profile",
  phone: "(410) 951-7680",
  city: "Baltimore",
  state: "MD"
}, {
  name: "Legal Aid Services of Oklahoma, Inc.",
  address: "2915 North Classen Boulevard, Suite 500, Oklahoma City, OK 73106",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-services-oklahoma-inc-program-profile",
  phone: "(405) 557-0020",
  city: "Oklahoma City",
  state: "OK"
}, {
  name: "Oklahoma Indian Legal Services, Inc.",
  address: "4200 Perimeter Center Drive, Suite 222, Oklahoma City, OK 73112",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/oklahoma-indian-legal-services-inc-program-profile",
  phone: "(405) 943-6457",
  city: "Oklahoma City",
  state: "OK"
}, {
  name: "Appalachian Research and Defense Fund of Kentucky",
  address: "120 North Front Avenue, Prestonsburg, KY 41653",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/appalachian-research-and-defense-fund-kentucky-program-profile",
  phone: "(606) 886-9876",
  city: "Prestonsburg",
  state: "KY"
}, {
  name: "Kentucky Legal Aid",
  address: "1700 Destiny Lane, Bowling Green, KY 42104",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/kentucky-legal-aid-program-profile",
  phone: "(270) 782-1924",
  city: "Bowling Green",
  state: "KY"
}, {
  name: "Legal Aid of the Bluegrass",
  address: "104 East Seventh Street, Covington, KY 41011-1740",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-bluegrass-program-profile",
  phone: "(859) 431-8200",
  city: "Covington",
  state: "KY"
}, {
  name: "Legal Aid Society",
  address: "416 West Muhammad Ali Boulevard, Suite 300, Louisville, KY 40202-2354",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-society-program-profile",
  phone: "(502) 584-1254",
  city: "Louisville",
  state: "KY"
}, {
  name: "Legal Aid Services of Oregon",
  address: "520 SW Sixth Avenue, Suite 1130, Portland, OR 97204",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-services-oregon-program-profile",
  phone: "(503) 224-4094",
  city: "Portland",
  state: "OR"
}, {
  name: "Nevada Legal Services, Inc.",
  address: "701 East Bridger Avenue, Suite 700, Las Vegas, NV 89101",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/nevada-legal-services-inc-program-profile",
  phone: "(702) 386-0404",
  city: "Las Vegas",
  state: "NV"
}, {
  name: "Legal Action of Wisconsin, Inc.",
  address: "230 West Wells Street, Room 800, Milwaukee, WI 53203-1866",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-action-wisconsin-inc-program-profile",
  phone: "(414) 278-7777",
  city: "Milwaukee",
  state: "WI"
}, {
  name: "Wisconsin Judicare, Inc.",
  address: "401 Fifth Street, Suite 200, P.O. Box 6100, Wausau, WI 55403",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/wisconsin-judicare-inc-program-profile",
  phone: "(715) 842-1681",
  city: "Wausau",
  state: "WI"
}, {
  name: "New Mexico Legal Aid",
  address: "505 Marquette Ave NW, Suite 700, Albuquerque NM 87125",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/new-mexico-legal-aid-program-profile",
  phone: "1-(833) 545-4357",
  city: "Albuquerque",
  state: "NM"
}, {
  name: "Legal Aid of Western Missouri",
  address: "4001 Blue Parkway, Suite 300, Kansas City, MO 64130",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-western-missouri-program-profile",
  phone: "(816) 474-6750",
  city: "Kansas City",
  state: "MO"
}, {
  name: "Legal Services of Eastern Missouri, Inc.",
  address: "4232 Forest Park Avenue, St. Louis, MO 63108",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-services-eastern-missouri-inc-program-profile",
  phone: "(314) 534-4200",
  city: "St. Louis",
  state: "MO"
}, {
  name: "Legal Services of Southern Missouri",
  address: "809 N. Campbell Avenue, Springfield, MO 65802",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-services-southern-missouri-program-profile",
  phone: "(417) 881-1397",
  city: "Springfield",
  state: "MO"
}, {
  name: "Mid-Missouri Legal Services Corporation",
  address: "1201 West Broadway, Columbia, MO 65203",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/mid-missouri-legal-services-corporation-program-profile",
  phone: "(573) 442-0116",
  city: "Columbia",
  state: "MO"
}, {
  name: "Blue Ridge Legal Services, Inc.",
  address: "204 North High Street, P.O. Box 551, Harrisonburg, VA 22803",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/blue-ridge-legal-services-inc-program-profile",
  phone: "(540) 433-1830",
  city: "Harrisonburg",
  state: "VA"
}, {
  name: "Central Virginia Legal Aid Society, Inc.",
  address: "101 West Broad Street, Suite 101, P.O. Box 12206, Richmond, VA 23241-2206",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/central-virginia-legal-aid-society-inc-program-profile",
  phone: "(804) 648-1012",
  city: "Richmond",
  state: "VA"
}, {
  name: "Legal Aid Society of Eastern Virginia",
  address: "125 St. Paul's Boulevard, Suite 400, Norfolk, VA 23510",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-society-eastern-virginia-program-profile",
  phone: "(757) 827-5078",
  city: "Norfolk",
  state: "VA"
}, {
  name: "Legal Services of Northern Virginia, Inc.",
  address: "4080 Chain Bridge Road, 1st Floor, Fairfax, VA 22030",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-services-northern-virginia-inc-program-profile",
  phone: "(703) 778-6800",
  city: "Fairfax",
  state: "VA"
}, {
  name: "Virginia Legal Aid Society, Inc.",
  address: "513 Church Street, P.O. Box 6200, Lynchburg, VA 24505-6200",
  phone: "(434) 528-4722",
  city: "Lynchburg",
  state: "VA",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/virginia-legal-aid-society-inc-program-profile"
}, {
  name: "Atlanta Legal Aid Society, Inc.",
  address: "54 Ellis Street NE, Atlanta, GA 30303",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/atlanta-legal-aid-society-inc-program-profile",
  phone: "(404) 524-5811",
  city: "Atlanta",
  state: "GA"
}, {
  name: "Georgia Legal Services Program",
  address: "104 Marietta Street, Suite 250, Atlanta, GA 30303-2848",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/georgia-legal-services-program-program-profile",
  phone: "(404) 563-7710",
  city: "Atlanta",
  state: "GA"
}, {
  name: "Legal Aid of Nebraska",
  address: "209 S. 19th Street, Suite 200, Omaha, NE 68102-2533",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-nebraska-program-profile",
  phone: "(402) 348-1069",
  city: "Omaha",
  state: "NE"
}, {
  name: "Anishinabe Legal Services, Inc.",
  address: "411 1st Street, NW, P.O. Box 157, Cass Lake, MN 56633-0157",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/anishinabe-legal-services-inc-program-profile",
  phone: "(218) 335-2223",
  city: "Cass Lake",
  state: "MN"
}, {
  name: "Central Minnesota Legal Services, Inc.",
  address: "430 First Avenue North, Suite 359, Minneapolis, MN 55401-1780",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/central-minnesota-legal-services-inc-program-profile",
  phone: "(612) 332-8151",
  city: "Minneapolis",
  state: "MN"
}, {
  name: "Legal Aid Service of Northeastern Minnesota",
  address: "302 Ordean Building, 424 West Superior Street, Duluth, MN 55802-1540",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-service-northeastern-minnesota-program-profile",
  phone: "(218) 623-8100",
  city: "Duluth",
  state: "MN"
}, {
  name: "Legal Services of Northwest Minnesota Corporation",
  address: "1015 7th Avenue North, P.O. Box 838, Moorhead, MN 56561-0838",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-services-northwest-minnesota-corporation-program-profile",
  phone: "(218) 233-8585",
  city: "Moorhead",
  state: "MN"
}, {
  name: "Kansas Legal Services, Inc.",
  address: "712 South Kansas Avenue, Suite 200, Topeka, KS 66603",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/kansas-legal-services-inc-program-profile",
  phone: "(785) 233-2068",
  city: "Topeka",
  state: "KS"
}, {
  name: "Acadiana Legal Service Corporation",
  address: "1020 Surrey Street, P.O. Box 4823, Lafayette, LA 70502-4823",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/acadiana-legal-service-corporation-program-profile",
  phone: "(337) 237-4320",
  city: "Lafayette",
  state: "LA"
}, {
  name: "Southeast Louisiana Legal Services Corporation",
  address: "1340 Poydras St, Suite 600, New Orleans, LA 70112",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/southeast-louisiana-legal-services-corporation-program-profile",
  phone: "(504) 529-1000",
  city: "New Orleans",
  state: "LA"
}, {
  name: "Legal Aid Society of Hawaii",
  address: "924 Bethel Street, Honolulu, HI 96813",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-society-hawaii-program-profile",
  phone: "(808) 536-4302",
  city: "Honolulu",
  state: "HI"
}, {
  name: "Alaska Legal Services Corporation",
  address: "1016 W. 6th Avenue, Suite 200, Anchorage, AK 99501-0963",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/alaska-legal-services-corporation",
  phone: "(907) 272-9431",
  city: "Anchorage",
  state: "AK"
}, {
  name: "Central Jersey Legal Services, Inc.",
  address: "317 George Street, Suite 201, New Brunswick, NJ 08901-2006",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/central-jersey-legal-services-inc-program-profile",
  phone: "(732) 249-7600",
  city: "New Brunswick",
  state: "NJ"
}, {
  name: "Essex-Newark Legal Services Project, Inc.",
  address: "5 Commerce Street, 2nd Floor, Newark, NJ 07102",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/essex-newark-legal-services-project-inc-program-profile",
  phone: "(973) 624-4500",
  city: "Newark",
  state: "NJ"
}, {
  name: "Legal Services of Northwest Jersey",
  address: "90 East Main Street, Somerville, NJ 08876-2218",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-services-northwest-jersey-program-profile",
  phone: "(908) 231-0840",
  city: "Newark",
  state: "NJ"
}, {
  name: "Northeast New Jersey Legal Services Corporation",
  address: "574 Summit Avenue, Jersey City NJ 07306-2797",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/northeast-new-jersey-legal-services-corporation-program-profile",
  phone: "(201) 792-6363",
  city: "Somerville",
  state: "NJ"
}, {
  name: "Idaho Legal Aid Services, Inc.",
  address: "1447 S. Tyrell Lane, Boise, ID 83706-4044",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/idaho-legal-aid-services-inc-program-profile",
  phone: "(208) 336-8980",
  city: "Boise",
  state: "ID"
}, {
  name: "Legal Services Alabama, Inc.",
  address: "2567 Fairlane Drive, Suite II & III, Montgomery, AL 36116",
  url: "http://www.legalservicesalabama.org/",
  phone: "(334) 223-5120",
  city: "Montgomery",
  state: "AL"
}, {
  name: "Iowa Legal Aid",
  address: "1111 Ninth Street, Suite 230, Des Moines, IA 50314-2527",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/iowa-legal-aid-program-profile",
  phone: "(515) 243-2980",
  city: "Des Moines",
  state: "IA"
}, {
  name: "Center for Arkansas Legal Services",
  address: "1300 W. 6th Street, Little Rock, AR 72201-3593",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/center-arkansas-legal-services-program-profile",
  phone: "(501) 376-3423",
  city: "Little Rock",
  state: "AR"
}, {
  name: "Legal Aid of Arkansas, Inc.",
  address: "714 South Main Street, Jonesboro, AR 72401",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-arkansas-inc-program-profile",
  phone: "(870) 972-9224",
  city: "Jonesboro",
  state: "AR"
}, {
  name: "Utah Legal Services, Inc.",
  address: "205 North 400 West, Salt Lake City, UT 84103-1125",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/utah-legal-services-inc-program-profile",
  phone: "(801) 924-3381",
  city: "Salt Lake City",
  state: "UT"
}, {
  name: "Rhode Island Legal Services, Inc.",
  address: "56 Pine Street, 4th Floor, Providence, RI 02903",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/rhode-island-legal-services-inc-program-profile",
  phone: "(401) 274-2652",
  city: "Providence",
  state: "RI"
}, {
  name: "Mississippi Center for Legal Services",
  address: "111 East Front Street, P.O. Drawer 1728, Hattiesburg, MS 39403-1728",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/mississippi-center-legal-services-program-profile",
  phone: "(601) 545-2950",
  city: "Hattiesburg",
  state: "MS"
}, {
  name: "North Mississippi Rural Legal Services, Inc.",
  address: "5 County Road 1014, P.O. Box 767, Oxford, MS 38655-0767",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/north-mississippi-rural-legal-services-inc-program-profile",
  phone: "(662) 234-8731",
  city: "Oxford",
  state: "MS"
}, {
  name: "Dakota Plains Legal Services, Inc.",
  address: "160 Second Street, P.O. Box 727, Mission, SD 57555-0727",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/dakota-plains-legal-services-inc-program-profile",
  phone: "(605) 856-4444",
  city: "Mission",
  state: "SD"
}, {
  name: "East River Legal Services",
  address: "335 North Main Avenue, Suite 300, Sioux Falls, SD 57104",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/east-river-legal-services-program-profile",
  phone: "(605) 336-9230",
  city: "Sioux Falls",
  state: "SD"
}, {
  name: "Statewide Legal Services of Connecticut, Inc.",
  address: "1290 Silas Deane Highway, Suite 3A, Wethersfield, CT 06109",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/statewide-legal-services-connecticut-inc-program-profile",
  phone: "(860) 344-8096",
  city: "Wethersfield",
  state: "CT"
}, {
  name: "South Carolina Legal Services, Inc.",
  address: "701 S Main Street, Greenville, SC 29601",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/south-carolina-legal-services-inc-program-profile",
  phone: "(803) 744-4179",
  city: "Greenville",
  state: "SC"
}, {
  name: "Legal Services of North Dakota",
  address: "418 E Broadway #7, Bismarck, ND 58502-1893",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-services-north-dakota-program-profile",
  phone: "(701) 222-2110",
  city: "Bismarck",
  state: "ND"
}, {
  name: "Legal Advice & Referral Center, Inc.",
  address: "15 Green Street, Concord, NH 03301-4823",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-advice-referral-center-inc-program-profile",
  phone: "(603) 224-5723",
  city: "Concord",
  state: "NH"
}, {
  name: "Montana Legal Services Association",
  address: "616 Helena Avenue, Suite 100, Helena, MT 59601",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/montana-legal-services-association-program-profile",
  phone: "(406) 442-9830",
  city: "Helena",
  state: "MT"
}, {
  name: "Legal Services Corporation of Delaware, Inc.",
  address: "100 West 10th Street, Suite 203, Wilmington, DE 19801",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-services-corporation-delaware-inc-program-profile",
  phone: "(302) 575-0408",
  city: "Wilmington",
  state: "DE"
}, {
  name: "Pine Tree Legal Assistance, Inc.",
  address: "88 Federal Street, P.O. Box 547, Portland, ME 04112-0547",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/pine-tree-legal-assistance-inc-program-profile",
  phone: "(207) 774-4753",
  city: "Portland",
  state: "ME"
}, {
  name: "Legal Aid of Wyoming, Inc.",
  address: "1813 Carey Ave., Cheyenne, WY 82001",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-wyoming-inc-program-profile",
  phone: "(877) 432-9955",
  city: "Cheyenne",
  state: "WY"
}, {
  name: "Legal Aid of West Virginia, Inc.",
  address: "922 Quarrier Street, 4th Floor, Charleston, WV 25301",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-aid-west-virginia-inc-program-profile",
  phone: "(304) 343-3013",
  city: "Charleston",
  state: "WV"
}, {
  name: "Legal Services Vermont",
  address: "274 North Winooski Avenue, Burlington, VT 05401",
  url: "https://www.lsc.gov/grants-grantee-resources/our-grantees/legal-services-law-line-vermont-inc-program-profile",
  phone: "(802) 863-7153",
  city: "Burlington",
  state: "VT"
}];